import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'aw-form-field-error',
  templateUrl: 'form-field-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldErrorComponent {}
